import { Component, Input } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { EspaceDocumentaireService } from '@kv-common-components/kx-services';
import { CommonConsentementInfoComponent } from '@kv-common-components/kv-common-components';
@Component({
    selector: 'app-consentement-info',
    templateUrl: './consentement-info.component.html',
    styleUrls: [],
})
export class ConsentementInfoComponent extends CommonConsentementInfoComponent {
    @Input() conventionAERAS: any;
    @Input() droitOubli: any;
    @Input() idDossier: any;
    @Input() topSansSelectionMedicale;
    constructor(
        protected logger: NGXLogger,
        protected espaceDocumentaireService: EspaceDocumentaireService
    ) {
        super(logger, espaceDocumentaireService);
    }
}
